/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Layout from "../../Components/ehealth/Layout";
import { getIcon } from "../../Components/Functions";
import { CallToAction } from "../../Components/Utils";
import { routers } from "../../Constants/routers";
import { updateSignup } from "../../Redux/Signup/actions";

export const UsernameSearch = (props) => {
	const updateSignup = (e) => {
        props.updateSignup({ ...props?.signup, ...e })
    }
	return (
		<div
			className="card card-form"
			data-x-data="initHeroCreateListingForm()"
			data-x-init="initSelects()"
			style={{ boxShadow: "none" }}
		>
			<div className="head">
				<h2 className="title is-5 text-primary">
					Create an account
				</h2>
				<form>
					<a className="bottom-link">Start by choosing a username</a>
					<div className="field">
						<div className="control has-icon">
							<input
								type={"text"}
								className="input is-bigger"
								placeholder="Choose username"
								style={{ background: "transparent" }}
								onInput={e => updateSignup({ username: e.target.value })}
								defaultValue={props?.signup?.username}
							/>
							<div className="form-icon" dangerouslySetInnerHTML={{ __html: getIcon("at-sign") }} />
							<p className={`${(props?.signup?.username || props?.signup?.searching) ? "":"d-none"} ${props?.signup?.check?.status?"text-success":"text-danger"}`} style={{ fontSize: 12 }}>
							<b style={{ fontWeight: 900 }}>{props?.signup?.username}</b> {props?.signup?.check?.status ? <>is available</> : props?.signup?.check?.detail || <>is not available</>}
							</p>
						</div>
					</div>
					{props?.signup?.check?.status && (
						<div className="field">
							<div className="control">
								<Link className={`button is-primary is-fullwidth ${props?.signup?.searching?"is-loading":""}`}
									onClick={() => props?.callback && props?.callback()}
									to={routers.auth.register}
								>
									{props?.signup?.check?.status ? "Available! Continue" : "Choose a username"}
								</Link>
							</div>
						</div>
					)}
				
				</form>
			</div>
		</div>
	)
}


const BecomeSpecialist = (props) => {
   
	return (
		<Layout isHome={true} hideSearch={true}>
			<div
				className="hero is-big is-grey is-bold has-form"
				data-background="https://dummyimage.com/1920x1080"
				data-demo-background={require("../../assets/images/pexels-tima-miroshnichenko-5198239.jpg").default}
			>
				<div className="hero-overlay" />
				<div className="hero-body">
					<div className="container">
						<div className="columns is-vcentered">
							<div className="column is-6">
								<div className="hero-text is-light">
									<h1 className="title is-1 is-bold">Be a Specialist</h1>
									<p className="subtitle is-left">
                                        Are you a certified medical specialist?
                                        Explore the benefits of being an 24Telemed specialist
                                        and start earning from your home.
									</p>
									<div className>
										<a className="button is-primary mx-1">Explore Benefits</a>
										<a className="button is-heavy mx-1">Learn More</a>
									</div>
								</div>
							</div>
							<div className="column is-6">
								<UsernameSearch {...props} />
							</div>
						</div>
					</div>
				</div>
			</div>
			
			
		</Layout>
	);
};


const mapStateToProps = ({ signup }) => {
	return { signup };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateSignup: (e) => dispatch(updateSignup(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BecomeSpecialist);







export const BecomeSpecialistX = () => {
	return (
		<>
		<div className="section">
				<div className="container">
					<div className="section-title has-text-centered py-6">
						<div className="title-divider" />
						<h1 className="title is-2 is-bold">3 Steps to become a Specialist</h1>
					</div>
					<div className="checked-features-grid py-6">
						<div className="columns is-flex-tablet-p">
							{/*Feature*/}
							<div className="column is-4">
								<div className="check-wrap mb-4">
									<i data-feather="check" />
								</div>
								<h4 className="title is-5">
									Register for free
								</h4>
								<p className="stressed-1">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt. Non risu potius quam
									oratione eiciendum? Istic sum, inquit. Ita prorsus, inquam;
								</p>
							</div>
							{/*Feature*/}
							<div className="column is-4">
								<div className="check-wrap mb-4">
									<i data-feather="check" />
								</div>
								<h4 className="title is-5">Verify your Account</h4>
								<p className="stressed-1">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt
								</p>
							</div>
							{/*Feature*/}
							<div className="column is-4">
								<div className="check-wrap mb-4">
									<i data-feather="check" />
								</div>
								<h4 className="title is-5">
									Start offering your service to interested people
								</h4>
								<p className="stressed-1">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt. Non risu potius quam
									oratione eiciendum?
								</p>
								{/* <a className="underlink my-4">Start listing your services</a> */}
							</div>
						</div>
					</div>
					<div className="py-6">
						<div className="columns is-vcentered is-flex-tablet-p">
							<div className="column is-5">
								<i className="fas fa-2x fa-quote-left mb-4 text-secondary" />
								<h4 className="title is-2 is-thin is-thin-mobile has-space">
									Connect with your specialist online.
								</h4>
								 
							</div>
							<div className="column is-6 is-offset-1">
								<img
									src={require("../../assets/images/pexels-thirdman-5327914.jpg").default}
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="section is-light-grey">
				<div className="container">
					{/*Title*/}
					<div className="section-title has-text-centered py-6">
						<div className="title-divider" />
						<h1 className="title is-2 is-bold">Some serious warranties</h1>
					</div>
					<div className="py-6">
						<div className="columns mb-6">
							<div className="column is-5">
								<p className="stressed-1 mb-2">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt. Non risu potius quam
									oratione eiciendum?
								</p>
								<p className="stressed-1">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt. Non risu potius quam
									oratione eiciendum?
								</p>
								
							</div>
							<div className="column is-6 is-offset-1">
								{/*Benefit*/}
								<div className="media-flex-center">
									<div className="check-wrap">
										<i data-feather="check" />
									</div>
									<div className="flex-meta">
										<span>100% Backed events</span>
										<span>
											If one of your attendees cancels, you still keep the
											earnings
										</span>
									</div>
								</div>
								{/*Benefit*/}
								<div className="media-flex-center">
									<div className="check-wrap">
										<i data-feather="check" />
									</div>
									<div className="flex-meta">
										<span>Set your rules</span>
										<span>
											Attendees and customer must follow the rules you set
										</span>
									</div>
								</div>
								{/*Benefit*/}
								<div className="media-flex-center">
									<div className="check-wrap">
										<i data-feather="check" />
									</div>
									<div className="flex-meta">
										<span>Breakage insurance</span>
										<span>
											We back you up with a breakage insurance for physical
											events.
										</span>
									</div>
								</div>
								{/*Benefit*/}
								<div className="media-flex-center">
									<div className="check-wrap">
										<i data-feather="check" />
									</div>
									<div className="flex-meta">
										<span>24/24 Support</span>
										<span>Our support team is available 24/24</span>
									</div>
								</div>
							</div>
						</div>
						<img
							src={require("../../assets/images/pexels-tima-miroshnichenko-5198239.jpg").default}
							alt=""
						/>
					</div>
				</div>
			</div>
			<div className="section">
				<div className="container">
					{/*Title*/}
					<div className="section-title has-text-centered py-6">
						<div className="title-divider" />
						<h1 className="title is-2 is-bold">Simple payments</h1>
					</div>
					<div className="py-6">
						<div className="columns">
							{/*Feature*/}
							<div className="column is-4">
								<h4 className="title is-5">
									Schedule your offers and events 100% Free
								</h4>
								<p className="stressed-1">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt. Non risu potius quam
									oratione eiciendum? Istic sum, inquit. Ita prorsus, inquam;
								</p>
							</div>
							{/*Feature*/}
							<div className="column is-4">
								<h4 className="title is-5">Define your Terms</h4>
								<p className="stressed-1">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt
								</p>
							</div>
							{/*Feature*/}
							<div className="column is-4">
								<h4 className="title is-5">
									Start offering your service to interested people
								</h4>
								<p className="stressed-1">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt. Non risu potius quam
									oratione eiciendum?
								</p>
							
							</div>
						</div>
					</div>
					<div className="py-6">
						<div className="columns is-vcentered is-flex-tablet-p">
							<div className="column is-6">
								<img
									src="https://dummyimage.com/500x500/ededed/000000"
									data-demo-src="https://listkit.cssninja.io/img/photo/content/people/square-3.jpg"
									alt
								/>
							</div>
							<div className="column is-5 is-offset-1">
								<i className="fas fa-2x fa-quote-left mb-4 text-secondary" />
								<h4 className="title is-2 is-thin is-thin-mobile has-space">
									I had trouble finding a job. Then I simply decided to start
									teaching online and it actually worked!
								</h4>
								<p>
									Helena's industrial design classes are followed by more than
									million people. She became quickly very popular.
								</p>
								<div className="py-4">
									<a className="button is-primary is-outlined is-raised-hover">
										Read Helena's Story
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="section">
				<div className="container">
					{/*Title*/}
					<div className="section-title has-text-centered py-6">
						<div className="title-divider" />
						<h1 className="title is-2 is-bold">Frequent Questions</h1>
					</div>
					{/*FAQ*/}
					<div className="py-6">
						<div className="columns is-vcentered">
							<div className="column is-5">
								<h4 className="title is-5 has-space">
									Start offering your service to interested people
								</h4>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit.
									Maximus dolor, inquit, brevis est. Comprehensum, quod cognitum
									non habet? Si longus, levis dictata sunt. Non risu potius quam
									oratione eiciendum?
								</p>
							
							</div>
							<div className="column is-6 is-offset-1">
								<div
									className="accordion"
									data-x-data="initAccordion()"
									data-x-init="setup()"
								>
									<div className="accordion-item">
										<button id="accordion-button-1" aria-expanded="false">
											<span className="accordion-title">
												Can I offer more then a service?
											</span>
											<span className="icon" aria-hidden="true" />
										</button>
										<div className="accordion-content">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipiscing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua. Elementum sagittis vitae et leo duis ut.
												Ut tortor pretium viverra suspendisse potenti.
											</p>
										</div>
									</div>
									<div className="accordion-item">
										<button id="accordion-button-2" aria-expanded="false">
											<span className="accordion-title">
												Can I get paid with Cryptos?
											</span>
											<span className="icon" aria-hidden="true" />
										</button>
										<div className="accordion-content">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipiscing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua. Elementum sagittis vitae et leo duis ut.
												Ut tortor pretium viverra suspendisse potenti.
											</p>
										</div>
									</div>
									<div className="accordion-item">
										<button id="accordion-button-3" aria-expanded="false">
											<span className="accordion-title">
												May I have more than one host account?
											</span>
											<span className="icon" aria-hidden="true" />
										</button>
										<div className="accordion-content">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipiscing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua. Elementum sagittis vitae et leo duis ut.
												Ut tortor pretium viverra suspendisse potenti.
											</p>
										</div>
									</div>
									<div className="accordion-item">
										<button id="accordion-button-4" aria-expanded="false">
											<span className="accordion-title">
												Can I sell trip packages?
											</span>
											<span className="icon" aria-hidden="true" />
										</button>
										<div className="accordion-content">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipiscing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua. Elementum sagittis vitae et leo duis ut.
												Ut tortor pretium viverra suspendisse potenti.
											</p>
										</div>
									</div>
									<div className="accordion-item">
										<button id="accordion-button-5" aria-expanded="false">
											<span className="accordion-title">
												How much is the commission?
											</span>
											<span className="icon" aria-hidden="true" />
										</button>
										<div className="accordion-content">
											<p>
												Lorem ipsum dolor sit amet, consectetur adipiscing elit,
												sed do eiusmod tempor incididunt ut labore et dolore
												magna aliqua. Elementum sagittis vitae et leo duis ut.
												Ut tortor pretium viverra suspendisse potenti.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<CallToAction className={"pt"} />
				</div>
			</div>	
		</>
	)
}
